import React, { FC } from 'react';
import Content from './view/Content';
import ViewBase from 'src/components/ViewBase';
import HeaderContent from './view/HeaderContent';
import { Typography } from '@mui/material';

const Receipts: FC = () => {
  const Title = <Typography>החשבוניות שלי</Typography>;

  return (
    <ViewBase Title={Title} HeaderContent={<HeaderContent />}>
      <Content />
    </ViewBase>
  );
};

export default Receipts;
